import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ConnectionService } from 'src/app/services/connection.service';
import { DataFieldsService } from 'src/app/services/data-fields.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-proposal',
  templateUrl: './proposal.component.html',
  styleUrls: ['./proposal.component.scss'],
})
export class ProposalComponent implements OnInit {
  previewForm:FormGroup;
  previewAddressForm:FormGroup;
  previewContactForm:FormGroup;
  previewEmailForm:FormGroup;
  previewIdForm:FormGroup;
  previewNomineeForm:FormGroup;
  membersDetail: any;
  fName:any;
  lName: any;
  gender: any;
  dob: any;
  relation: any;
  addType: any;
  addLine1: any;
  addLine2: any;
  area: any;
  city: any;
  state: any;
  country: any;
  pincode: any;
  contact: any;
  email: any;
  idType: any;
  idNumber: any;
  nmRelation: any;
  nmName: any;
  partyList: any = [];
  addressDetails: any[];
  questionSet: any=[];
  premium: any;
  idShow: boolean;
  idDetails: any=[];
  insurerDetails: any=[];
  modal: any;
  bussinessCode: string;
  term: any;
  constructor(private _datePipe: DatePipe,private datePipe: DatePipe,private modalCtrl: ModalController,private _dataFields: DataFieldsService,private fb: FormBuilder,private apiService: ConnectionService,private loader: LoaderService,private strg: StorageService) { }
  @Input() dataSelected: any;
  @Input() goForward: any;
  ngOnInit() {
    this.insurerDetails = this._dataFields.getInsurerList()
    this.previewForm=this.fb.group({
     previewDetails:new FormArray([
     ])
    })
    this.previewAddressForm=this.fb.group({
      previewAddressDetails:new FormArray([])
    })
    this.previewContactForm=this.fb.group({
      previewContactDetails:new FormArray([])
    })
    this.previewEmailForm=this.fb.group({
      previewEmailDetails:new FormArray([])
    })
    this.previewIdForm=this.fb.group({
      previewIdDetails:new FormArray([])
    })
    this.previewNomineeForm=this.fb.group({
      previewNomineeDetails:new FormArray([])
    })
    let policyMembers=this.dataSelected.intPolicyDataIO.policy.partyDOList;
    if(this.dataSelected.intPolicyDataIO.policy.addOns!=null){

    }
    policyMembers.forEach(element => {
      console.log(element)
    });
  }
  get previewControl(){
    return this.previewForm.controls
  }
  get previewGroup(){
    return this.previewControl.previewDetails as FormArray
  }
  get previewAddControl(){
    return this.previewAddressForm.controls
  }
  get previewAddGroup(){
    return this.previewAddControl.previewAddressDetails as FormArray
  }
  get previewContactDetails(){
    return this.previewContactForm.controls
  }
  get previewContactGroup(){
    return this.previewContactDetails.previewContactDetails as FormArray
  }
  get previewEmailControl(){
    return this.previewEmailForm.controls
  }
  get previewEmailGroup(){
    return this.previewEmailControl.previewEmailDetails as FormArray
  }
  get previewIdControl(){
    return this.previewIdForm.controls
  }
  get previewIdGroup(){
    return this.previewIdControl.previewIdDetails as FormArray
  }
  get previewNomineeControl(){
    return this.previewNomineeForm.controls
  }
  get previewNomineeGroup(){
    return this.previewNomineeControl.previewNomineeDetails as FormArray
  }
  ionViewDidEnter(){
    if(this.previewGroup.length < this.dataSelected.intPolicyDataIO.policy.partyDOList.length){
      let listMembers=this.dataSelected.intPolicyDataIO.policy.partyDOList;
      listMembers.forEach(element => {
        this.membersDetail=element;
        // this.questionSet.push(element.partyQuestionDOList)
        this.previewGroup.push(this.fb.group({
         // prview_relName:[element.name],
          prview_Guid:[element.guid],
          prview_title:[element.titleCd],
          prview_fName:[element.firstName],
          prview_lName:[element.lastName],
          prview_Gender:[element.genderCd],
          prview_Dob:[element.birthDt], 
          prview_height:[element.height],
          prview_weight:[element.weight],
          prview_Relation:[element.relationCd],
          prview_Rolecd:[element.roleCd],
          prview_queList:[element.partyQuestionDOList],
          prview_idList:[element.partyIdentityDOList]
        }))
      })
      this.membersDetail.partyAddressDOList.forEach(element => {
        this.addType=element.addressTypeCd;
        this.addLine1=element.addressLine1Lang1;
        this.addLine2=element.addressLine2Lang1;
        this.area=element.areaCd;
        this.city=element.cityCd;
        this.state=element.stateCd
        this.country=element.countryCd
        this.pincode=element.pinCode
        this.previewAddGroup.push(this.fb.group({
          prview_addType:[element.addressTypeCd],
          prview_addLine1:[element.addressLine1Lang1],
          prview_addLine2:[element.addressLine2Lang1],
          prview_addArea:[element.areaCd],
          prview_addCity:[element.cityCd],
          prview_addCountry:[element.countryCd],
          prview_addPincode:[element.pinCode],
          prview_addState:[element.stateCd],
        }))
      });  
       this.membersDetail.partyContactDOList.forEach(element => {
         this.contact=element.contactNum;
         this.previewContactGroup.push(this.fb.group({
           prview_Contact:[element.contactNum]
         }))
       });
       this.membersDetail.partyEmailDOList.forEach(element => {
         this.email=element.emailAddress
         this.previewEmailGroup.push(this.fb.group({
          prview_Email:[element.emailAddress]
         }))
       });
       this.membersDetail.partyIdentityDOList.forEach(element => {
         this.idType=element.identityTypeCd;
         this.idNumber=element.identityNum
         this.previewIdGroup.push(this.fb.group({
          prview_idType:[element.identityTypeCd],
          prview_idNumber:[element.identityNum]
         }))
       });
       let nomineeData=this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList
       nomineeData.forEach(element => {
         this.nmRelation=element.field12;
         this.nmName=element.field10;
         this.previewNomineeGroup.push(this.fb.group({
          prview_nmRelation:[element.field12],
          prview_nmName:[element.field10]
         }))
       });
    }
    this.strg.getStoreData("hcr_careQuoteResponse").then(value => {
      let quoteRes = value;
      if(this.dataSelected.intPolicyDataIO.policy.businessTypeCd != 'Enhance 1'){
        this.premium =quoteRes.careQuoteResponse.responseParam.grandTotal.selectedValue;
        if (this.premium.replace(/,/g, '') >= 50000) {
          this.idShow = true;
        }
        else if (this.premium.replace(/,/g, '') < 50000) {
          this.idShow = false;
        }
      }
    })
  }
  
  proceed(){
    let insurerDataArray = []
    // for(let i=0;i<this.dataSelected.intPolicyDataIO.policy.partyDOList.length;i++){
    //   this.questionSet=this.dataSelected.intPolicyDataIO.policy.partyDOList[i].partyQuestionDOList
    //   this.idDetails=this.dataSelected.intPolicyDataIO.policy.partyDOList[i].partyIdentityDOList
    // }
    this.previewForm.controls.previewDetails.value.forEach(element => { 
      this.partyList= {
        "guid": element.prview_Guid,//String(guid)
        "firstName": element.prview_fName,
        "lastName":element.prview_lName,
        "roleCd": element.prview_Rolecd,
        "height":element.prview_height,
        "weight":element.prview_weight,
        "birthDt": this.datePipe.transform(element.prview_Dob, "dd/MM/yyyy"),
        "genderCd":element.prview_Gender,
        "titleCd": element.prview_title,
        "relationCd": element.prview_Relation,
        // "partyQuestionDOList": this.questionSet,
        "partyQuestionDOList": element.prview_queList,
        "partyIdentityDOList": element.prview_idList,
        "partyAddressDOList": [{
          "addressTypeCd": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addType,
          "addressLine1Lang1": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addLine1,
          "addressLine2Lang1": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addLine2,
          "stateCd": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addState,
          "cityCd": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addCity,
          "pinCode": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addPincode,
          "areaCd": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addArea,
          "countryCd": this.previewAddressForm.controls.previewAddressDetails.value[0].prview_addCountry
        },
        {
          "addressTypeCd": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addType,
          "addressLine1Lang1": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addLine1,
          "addressLine2Lang1": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addLine2,
          "stateCd": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addState,
          "cityCd": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addCity,
          "pinCode": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addPincode,
          "areaCd": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addArea,
          "countryCd": this.previewAddressForm.controls.previewAddressDetails.value[1].prview_addCountry
        }],
        "partyContactDOList":[ {
          "contactTypeCd": "MOBILE",
          "contactNum": this.previewContactForm.controls.previewContactDetails.value[0].prview_Contact,
          "stdCode": "+91"
        }],
        "partyEmailDOList": [
          {
            "emailTypeCd": "PERSONAL",
            "emailAddress": this.previewEmailForm.controls.previewEmailDetails.value[0].prview_Email,
          }
        ]
      }
      insurerDataArray.push(this.partyList)
    });  
    if(this.dataSelected.intPolicyDataIO.policy.businessTypeCd != 'Enhance 1'){
      this.bussinessCode="10001101"
      this.term=this.dataSelected.intPolicyDataIO.policy.term
    }
    else if(this.dataSelected.intPolicyDataIO.policy.businessTypeCd === 'Enhance 1'){
      this.bussinessCode="11001001"
      if(this.dataSelected.intPolicyDataIO.policy.term === '1 Year' || this.dataSelected.intPolicyDataIO.policy.term === 1){
        this.term=1;
      }
      else if(this.dataSelected.intPolicyDataIO.policy.term === '2 Year'  || this.dataSelected.intPolicyDataIO.policy.term === 2){
        this.term=2;
      }
      else if(this.dataSelected.intPolicyDataIO.policy.term === '3 Year'  || this.dataSelected.intPolicyDataIO.policy.term === 3){
        this.term=3;
      }
    }
    if(this.dataSelected.intPolicyDataIO.policy.addOns===""){
      let submitFormData = {
        "quoteId": this.dataSelected.quoteId,
        "orderId": this.dataSelected.orderId,
        "intPolicyDataIO": {
          "policy": {
            "partyDOList": this.partyList,
            "policyAdditionalFieldsDOList": [
              {
                "fieldAgree":this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].fieldAgree,
                "fieldTc": this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].fieldTc,
                "fieldAlerts": this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].fieldAlerts,
                "field1": this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].field1,
                "field10": this.previewNomineeForm.controls.previewNomineeDetails.value[0].prview_nmName,
                "field12": this.previewNomineeForm.controls.previewNomineeDetails.value[0].prview_nmRelation,
              }
            ],
            "isPremiumCalculation": "YES",
            "businessTypeCd": "NEWBUSINESS",
            // "baseAgentId": "20008325",
            "baseAgentId": "20210682",
            "baseProductId": this.bussinessCode,
            "sumInsured": this.dataSelected.intPolicyDataIO.policy.sumInsured,
            "term": this.dataSelected.intPolicyDataIO.policy.term,
            "coverType": this.dataSelected.intPolicyDataIO.policy.coverType,
            //"addOns": this.dataSelected.intPolicyDataIO.policy.addOns,
            "sumInsuredValue": this.dataSelected.intPolicyDataIO.policy.sumInsuredValue, //String(this.sumInsured + " Lakhs"),
            "quotationPremium": this.dataSelected.intPolicyDataIO.policy.quotationPremium,
            "abacusId": this.dataSelected.intPolicyDataIO.policy.abacusId,//String(this.abacusId),
            "eldestMemberAge": this.dataSelected.intPolicyDataIO.policy.eldestMemberAge
          }
        }
        
      }
      submitFormData.intPolicyDataIO.policy.partyDOList = insurerDataArray;
      this.modalCtrl.dismiss({
        dataSelected: submitFormData,
        goForward: true,
      });
    }
    else {
      let submitFormData = {
        "quoteId": this.dataSelected.quoteId,
        "orderId": this.dataSelected.orderId,
        "intPolicyDataIO": {
          "policy": {
            "partyDOList": this.partyList,
            "policyAdditionalFieldsDOList": [
              {
                "fieldAgree":this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].fieldAgree,
                "fieldTc": this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].fieldTc,
                "fieldAlerts": this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].fieldAlerts,
                "field1": this.dataSelected.intPolicyDataIO.policy.policyAdditionalFieldsDOList[0].field1,
                "field10": this.previewNomineeForm.controls.previewNomineeDetails.value[0].prview_nmName,
                "field12": this.previewNomineeForm.controls.previewNomineeDetails.value[0].prview_nmRelation,
              }
            ],
            "isPremiumCalculation": "YES",
            "businessTypeCd": "NEWBUSINESS",
            // "baseAgentId": "20008325",
            "baseAgentId": "20210682",
            "baseProductId": this.bussinessCode,
            "sumInsured": this.dataSelected.intPolicyDataIO.policy.sumInsured,
            "term": this.term,
            "coverType": this.dataSelected.intPolicyDataIO.policy.coverType,
            "addOns": this.dataSelected.intPolicyDataIO.policy.addOns,
            "sumInsuredValue": this.dataSelected.intPolicyDataIO.policy.sumInsuredValue, //String(this.sumInsured + " Lakhs"),
            "quotationPremium": this.dataSelected.intPolicyDataIO.policy.quotationPremium,
            "abacusId": this.dataSelected.intPolicyDataIO.policy.abacusId,//String(this.abacusId),
            "eldestMemberAge": this.dataSelected.intPolicyDataIO.policy.eldestMemberAge
          }
        }
        
      }
      submitFormData.intPolicyDataIO.policy.partyDOList = insurerDataArray;
      this.modalCtrl.dismiss({
        dataSelected: submitFormData,
        goForward: true,
      });
    }
  }
  close(){
    this.modalCtrl.dismiss({
      //dataSelected: this.dataSelected,
      goForward: false,
    });
  }
  getPincode(e){
    let data = e.target.value
    //this.loader.showLoader();
    this.apiService.getPincode(data).subscribe(res => {
      this.previewAddressForm.controls.previewAddressDetails['controls'][0].controls.prview_addCity.setValue(res.data[0].cityCode)
      this.previewAddressForm.controls.previewAddressDetails['controls'][0].controls.prview_addArea.setValue(res.data[0].cityCode)
      this.previewAddressForm.controls.previewAddressDetails['controls'][0].controls.prview_addState.setValue(res.data[0].stateCode)
      this.previewAddressForm.controls.previewAddressDetails['controls'][1].controls.prview_addCity.setValue(res.data[0].cityCode)
      this.previewAddressForm.controls.previewAddressDetails['controls'][1].controls.prview_addArea.setValue(res.data[0].cityCode)
      this.previewAddressForm.controls.previewAddressDetails['controls'][1].controls.prview_addState.setValue(res.data[0].stateCode)
    })
  }
}
